import React, { useState, useCallback } from 'react'
import { TextField, Button, FormHelperText, Stack } from '@mui/material'
import { ConfirmButton } from '@/components/Button'
import Text from '@/components/Text'
import { Row } from './components'
import CreateIcon from '@mui/icons-material/Create'
import { primary } from '@/constant'
import { updateUserName } from '@/api'
import { useMutation } from '@tanstack/react-query'

export interface EditableNameProps {
  value: string
  onSave: () => void
}

const EditableName: React.FC<EditableNameProps> = (props) => {
  const { value, onSave } = props
  const [edit, setEdit] = useState<boolean>(false)
  const [formValue, setFormValue] = useState<string>('')

  const [error, setError] = useState<boolean>(false)

  const nickNameMutation = useMutation(updateUserName, {
    onSuccess: () => {
      onSave()
      setFormValue('')
      setEdit(false)
      setError(false)
    },
  })

  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = event.target
    setFormValue(inputValue)
  }, [])

  const handleSave = useCallback(() => {
    if (formValue?.length > 20) {
      setError(true)
    } else {
      nickNameMutation.mutate({ nickname: formValue })
    }
  }, [formValue, nickNameMutation])

  const handleEdit = useCallback(() => {
    setFormValue(value)
    setEdit(true)
  }, [value])

  const cancelEdit = useCallback(() => {
    setEdit(false)
  }, [])

  return (
    <Row sx={{ gap: '8px', alignItems: edit ? 'flex-start' : 'center' }}>
      {edit ? (
        <Stack>
          <TextField
            label={'用户名'}
            value={formValue}
            variant='outlined'
            size='small'
            InputProps={{
              sx: {
                width: '250px',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: primary },
              },
            }}
            InputLabelProps={{
              sx: {
                '& .Mui-focused': { color: `${primary} !important` },
                color: `${primary} !important`,
              },
            }}
            error={error}
            onChange={onChange}
          />
          {error && <FormHelperText error={error}>用户名不能超过20字</FormHelperText>}
        </Stack>
      ) : (
        <Text
          sx={{
            textOverflow: 'ellipsis',
            maxWidth: '20rem',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
          title={value}
        >
          {value}
        </Text>
      )}
      {edit ? (
        <Row>
          <ConfirmButton onClick={handleSave}>保存</ConfirmButton>
          <Button onClick={cancelEdit}>取消</Button>
        </Row>
      ) : (
        <CreateIcon onClick={handleEdit} sx={{ cursor: 'pointer', fontSize: '14px' }} />
      )}
    </Row>
  )
}

export default EditableName
